<template>
  <app-layout>
    <feedback topic="retrospective"></feedback>
    <template #header>
      <h2 class="font-bold text-2xl text-gray-800 leading-tight inline-flex">
        <img src="/images/retro.svg" class="h-8 w-8"/>
        <span class="ml-2"> Retrospective Dashboard</span>
      </h2>
    </template>

    <jet-dialog-modal maxWidth="2xl" :show="createRetroModal === true" @close="createRetroModal = false">


      <template #content>

        <create-retro-form :click-text="'Create Your Board'" @created="boardCreated"></create-retro-form>
      </template>

      <template #footer>
        <div class="text-md text-blue-500 font-bold inline-block ml-1">
          agilesuite.io
        </div>
      </template>
    </jet-dialog-modal>

    <div class="h-screen mt-1 flex overflow-hidden bg-gray-100">
      <div class=" flex flex-shrink-0">
        <div class="flex flex-col w-64">
          <div class="flex flex-col flex-grow border-r border-gray-200 pt-1 pb-4 bg-white overflow-y-auto">
            <div class="mt-2 flex-grow flex flex-col">
              <nav class="flex-1 px-2 bg-white space-y-1">
                <a @click="currentIndex = 3"
                   :class="{'bg-gray-100': currentIndex === 3 , 'text-gray-600': currentIndex !==3}"
                   class="cursor-pointer hover:bg-gray-50 hover:text-gray-900 group flex items-center px-2 py-2 text-sm font-medium rounded-md">
                  <!-- Heroicon name: outline/users -->
                  <ChartPieIcon
                      class="text-gray-400 group-hover:text-gray-500 mr-3 flex-shrink-0 h-6 w-6"></ChartPieIcon>
                  Retro Metrics
                </a>

                <a @click="currentIndex = 0"
                   :class="{'bg-gray-100': currentIndex === 0 , 'text-gray-600': currentIndex !==0}"
                   class="cursor-pointer hover:bg-gray-50 hover:text-gray-900 group flex items-center px-2 py-2 text-sm font-medium rounded-md">
                  <!-- Heroicon name: outline/users -->
                  <EyeIcon class="text-gray-400 group-hover:text-gray-500 mr-3 flex-shrink-0 h-6 w-6"></EyeIcon>
                  Public Boards
                </a>

                <a @click="currentIndex = 1"
                   :class="{'bg-gray-100': currentIndex === 1 , 'text-gray-600': currentIndex !==1}"
                   class="cursor-pointer hover:bg-gray-50 hover:text-gray-900 group flex items-center px-2 py-2 text-sm font-medium rounded-md">
                  <!-- Heroicon name: outline/users -->
                  <svg class="text-gray-400 group-hover:text-gray-500 mr-3 flex-shrink-0 h-6 w-6"
                       xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"
                       aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"/>
                  </svg>
                  Team Boards
                </a>
                <a @click="currentIndex = 2"
                   :class="{'bg-gray-100': currentIndex === 2 , 'text-gray-600': currentIndex !==2}"
                   class="cursor-pointer hover:bg-gray-50 hover:text-gray-900 group flex items-center px-2 py-2 text-sm font-medium rounded-md">
                  <!-- Heroicon name: outline/users -->
                  <LightBulbIcon
                      class="text-gray-400 group-hover:text-gray-500 mr-3 flex-shrink-0 h-6 w-6"></LightBulbIcon>
                  Action Boards
                </a>


                <a @click="currentIndex = 4"
                   :class="{'bg-gray-100': currentIndex === 4 , 'text-gray-600': currentIndex !==4}"
                   class="cursor-pointer hover:bg-gray-50 hover:text-gray-900 group flex items-center px-2 py-2 text-sm font-medium rounded-md">
                  <!-- Heroicon name: outline/users -->
                  <CogIcon class="text-gray-400 group-hover:text-gray-500 mr-3 flex-shrink-0 h-6 w-6"></CogIcon>
                  Retro Custom Flow
                </a>

                <a @click="this.$inertia.visit(route('teams.show',{team:$page.props.user.current_team_id }))"
                   :class="{'bg-gray-100': currentIndex === 5 , 'text-gray-600': currentIndex !==5}"
                   class="cursor-pointer hover:bg-gray-50 hover:text-gray-900 group flex items-center px-2 py-2 text-sm font-medium rounded-md">
                  <!-- Heroicon name: outline/users -->
                  <MenuIcon class="text-gray-400 group-hover:text-gray-500 mr-3 flex-shrink-0 h-6 w-6"></MenuIcon>
                  Team Management
                </a>
              </nav>
            </div>
          </div>
        </div>
      </div>
      <div class="flex flex-col w-0 flex-1 overflow-hidden">

        <main class="flex-1 relative overflow-y-auto focus:outline-none">
          <div class="py-6">

            <div class="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">


              <template v-if="currentIndex === 0">

                <public-board-list></public-board-list>

              </template>

              <template v-if="currentIndex === 1">

                <team-board-list></team-board-list>
              </template>

              <template v-if="currentIndex === 2">
                <ActionBoard></ActionBoard>
              </template>
              <template v-if="currentIndex === 3">
                <RetroMetrics></RetroMetrics>
              </template>
              <template v-if="currentIndex === 4">
                <CustomRetroFlow></CustomRetroFlow>
              </template>

            </div>


          </div>
        </main>
      </div>
    </div>

  </app-layout>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout";
import Button from "@/Jetstream/Button";
import {message} from "ant-design-vue";
import {
  ref,
  onMounted,
} from "vue";
import JetDialogModal from "@/Jetstream/DialogModal";
import CreateRetroForm from "@/Pages/Retrospective/CreateRetroForm";
import ActionBoard from "@/Pages/Retrospective/ActionBoard/ActionBoard";
import CustomRetroFlow from "@/Pages/Retrospective/CustomRetroFlow";
import PublicBoardList from "@/Pages/Retrospective/PublicBoardList";
import TeamBoardList from "@/Pages/Retrospective/TeamBoardList";
import TeamMemberManager from "@/Pages/Teams/TeamMemberManager";
import TeamSelectionDropdown from "@/Layouts/TeamSelectionDropdown";
import Show from "@/Pages/Teams/Show";
import Feedback from "@/Components/Feedback";
import RetroMetrics from "@/Pages/Retrospective/RetroMetrics";
import {
  ChartPieIcon,
  EyeIcon,
  LightBulbIcon,
  CogIcon,
  MenuIcon
} from "@heroicons/vue/outline";

export default {
  props: [],
  data() {
    return {
      currentIndex: 3,
      showSideBar: true,
      testStyle: '  background: -webkit-linear-gradient(90deg, #000 33%, rgba(0, 0, 0, 0) 33%), -webkit-linear-gradient(110deg, #dd0000 66%, #ffc608 66%);\n' +
          '  background: -o-linear-gradient(90deg, #000 33%, rgba(0, 0, 0, 0) 33%), -o-linear-gradient(110deg, #dd0000 66%, #ffc608 66%);\n' +
          '  background: -moz-linear-gradient(90deg, #000 33%, rgba(0, 0, 0, 0) 33%), -moz-linear-gradient(110deg, #dd0000 66%, #ffc608 66%);\n' +
          '  background: linear-gradient(90deg, #000 33%, rgba(0, 0, 0, 0) 33%), linear-gradient(110deg, #dd0000 66%, #ffc608 66%);'

    };
  },
  mounted() {
  },
  created() {
  },
  setup() {

    const cards = ref([]);
    const createRetroModal = ref(false);

    return {
      createRetroModal,
      cards,
    }
  },

  methods: {
    getColorBackgroundString(color) {
      return 'background: linear-gradient(to right, ' + color.join(',') + ');';
    },
    info(roomKey) {
      let testingCodeToCopy = document.querySelector("#board" + roomKey);
      testingCodeToCopy.setAttribute("type", "text"); // 不是 hidden 才能複製
      testingCodeToCopy.select();

      try {
        document.execCommand("copy");
        message.success("Your link is copied");
      } catch (err) {
        message.error("Oops, unable to copy");
      }

      /* unselect the range */
      testingCodeToCopy.setAttribute("type", "hidden");
      window.getSelection().removeAllRanges();
    },
    getLink(id) {
      return this.$page.props.env !== 'production' ? 'https://staging.agilesuite.io/boards/' + id : 'https://agilesuite.io/boards/' + id;
    },
  },
  components: {
    ChartPieIcon,
    EyeIcon,
    LightBulbIcon,
    CogIcon,
    MenuIcon,
    RetroMetrics,
    Feedback,
    Show,
    TeamSelectionDropdown,
    TeamMemberManager,
    TeamBoardList,
    PublicBoardList,
    CustomRetroFlow,
    ActionBoard,
    CreateRetroForm,
    JetDialogModal,
    Button,
    AppLayout,
  },
};
</script>
